import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import zhHant from 'vuetify/lib/locale/zh-Hant';

Vue.use(Vuetify)

const opts = {
    lang: {
        locales: { zhHant },
        current: 'zhHant',
    },
}

export default new Vuetify(opts)
